import {css} from '@emotion/css';
import {colours, spacing} from '@fo/shared/styles/variables';

const signContainerWidth = 3;

const styles = {
  currency: (isDisabled?: boolean): string => css`
    label: currency;

    position: relative;
    padding-left: ${signContainerWidth + 0.4}rem;

    &::before {
      position: absolute;
      display: block;
      width: ${signContainerWidth}rem;
      height: 4rem;
      margin-top: ${spacing.XXXS};
      margin-left: ${(signContainerWidth + 0.4) * -1}rem;
      background-color: ${colours.background.OFF_WHITE};
      border: 1px solid ${colours.border.LIGHT_GRAY};
      content: '';
    }
    &::after {
      position: absolute;
      top: 50%;
      left: 1.5rem;
      padding-top: 0.3rem;
      color: ${colours.font.ASSISTIVE};
      font-size: 2.2rem;
      text-align: center;
      transform: translate(-50%, -50%);
      content: attr(data-currency-symbol);
    }

    ${isDisabled
      ? css`
          &::before,
          &::after {
            color: ${colours.font.DISABLED};
          }
        `
      : ''}
  `,
};

export default styles;
